<div class="text-left">
  <!-- <div class="selectedLeaveType"><b>Leave Type</b></div> -->
  <div class="relative">
    <ng-select #leaveTypeSelect [(ngModel)]="default" style="border-radius: 20px; width: 150px" [items]="newlyAdded"
      bindLabel="label" bindValue="" [multiple]="false" [closeOnSelect]="true" [loading]="leavetypeLoading"
      [typeahead]="leavetypeInput$" placeholder="Leave Type" [virtualScroll]="true"
      [(ngModel)]="selectedLeaveType"></ng-select>

  </div>
</div>